export default {
  meta: {
    title: '资产经营'
  }
};
